export const RapbackSummaryStyles = {
    rapbackDrawerBox: {
        padding: '1rem 1.75rem ', 
        width: '55rem', 
        minHeight: '100vh', 
        backgroundColor: 'background.default',  
        overflowY: 'hidden'
    }
}